import * as action from './action_types';

export function userAuth(data) {
    return {
        type: action.API_USERAUTH_FETCH,
        data: data
    }
};

